import { importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { inputTypeComponents } from './configs/input-type-components.config';
import { inputTypeComponents as orderWorkflowInputTypes } from '@features/client/order-workflow/configs/input-type-components.config';
import { inputTypeWrappers } from '@shared/configs/input-type-wrappers.config';
import { CheckboxInputTypeBuilder } from './builders/checkbox-input-type.builder';
import { CheckboxListInputTypeBuilder } from './builders/checkbox-list-input-type.builder';
import { TextInputTypeBuilder } from './builders/text-input-type.builder';
import { TextareaInputTypeBuilder } from './builders/textarea-input-type.builder';
import { LabelInputTypeBuilder } from './builders/label-input-type.builder';
import { EmailInputTypeBuilder } from './builders/email-input-type.builder';
import { ImageInputTypeBuilder } from './builders/image-input-type.builder';
import { NumberInputTypeBuilder } from './builders/number-input-type.builder';
import { DateInputTypeBuilder } from './builders/date-input-type.builder';
import { RadioInputTypeBuilder } from './builders/radio-input-type.builder';
import { DropdownInputTypeBuilder } from './builders/dropdown-input-type.builder';
import { CustomInputTypeBuilder } from './builders/custom-input-type.builder';
import { FileInputTypeBuilder } from './builders/file-input-type.builder';
import { ColorSystemInputTypeBuilder } from './builders/color-system-input-type.builder';
import { ImplantCustomInputTypeBuilder } from './builders/implant-custom-input-type.builder';
import { CalendarInputTypeBuilder } from './builders/calendar-input-type.builder';
import { CustomButtonInputTypeBuilder } from './builders/custom-button-input-type.builder';

export function provideFormBuilder() {
  return makeEnvironmentProviders([
    importProvidersFrom(
      FormlyModule.forChild({
        types: [...inputTypeComponents, ...orderWorkflowInputTypes],
        wrappers: inputTypeWrappers,
      }),
    ),
    CheckboxInputTypeBuilder,
    CheckboxListInputTypeBuilder,
    TextInputTypeBuilder,
    TextareaInputTypeBuilder,
    LabelInputTypeBuilder,
    EmailInputTypeBuilder,
    ImageInputTypeBuilder,
    NumberInputTypeBuilder,
    DateInputTypeBuilder,
    RadioInputTypeBuilder,
    DropdownInputTypeBuilder,
    CustomInputTypeBuilder,
    FileInputTypeBuilder,
    ColorSystemInputTypeBuilder,
    ImplantCustomInputTypeBuilder,
    CalendarInputTypeBuilder,
    CustomButtonInputTypeBuilder,
  ]);
}
